import React from 'react';
import { Popup, PopupProps } from '@progress/kendo-react-popup';

export const CustomDatePopup = (props: PopupProps) => {
  return <Popup {...props} animate={false} />;
};
